/**
 * Checks if a string is empty or null
 * @param str
 */

export function isEmpty(
  str: string | null | undefined
): str is null | undefined | "" {
  return str == null || str === "";
}

export function dateToString(date: Date): string {
  const day = String(date.getDate()).padStart(2, "0"); // convert day to two-digit format with leading zeros
  const month = String(date.getMonth() + 1).padStart(2, "0"); // convert month to two-digit format with leading zeros
  const year = date.getFullYear().toString().padStart(4, "0"); // get full year (e.g. 2023)
  return `${year}-${month}-${day}`;
}
/**
 * Returns the current date in ISO format
 */
export function getTodayString() {
  return new Date().toISOString().split("T")[0];
}
